import CustomizedButton from "@components/ButtonConfirm/ButtonConfirm";
import CreateQuoteForm from "@components/CreateQuoteForm/CreateQuoteForm";
import React from "react";
import Modal from "react-modal";

const UpdateQuoteModal = ({
  modal,
  handleCloseModal,
  handleModalSave,
  title,
  isUpdate,
  modalFields,
  reset,
}) => {
  console.log("🚀 ~ UpdateQuoteModal ~ modal:", modal);
  if (!modal) return null;

  return (
    <Modal
      isOpen={!!modal}
      onRequestClose={handleCloseModal}
      contentLabel={title || "Modifier le devis"}
      className="invoice-modal"
      style={{
        content: { width: "80vw", maxHeight: "95vh", overflow: "auto" },
      }}>
      <CreateQuoteForm
        isUpdate={true}
        initialValues={modalFields}
        onSave={handleModalSave}
        onCancel={handleCloseModal}
        reset={reset}
      />
      <div
        className="d-flex justify-content-end mt-4"
        style={{ width: "100%" }}>
        <div style={{ width: "10%" }}>
          <CustomizedButton
            finalizeText={"Annuler"}
            bgColor={"#CACACA"}
            handleCreate={handleCloseModal}
          />
        </div>
      </div>
    </Modal>
  );
};

export default UpdateQuoteModal;
